import React from 'react'
import {api} from 'lib/url'
import {useParams} from 'react-router-dom'
import DownloadFile from 'organization/DownloadFile'

export default function DownloadImageEntriesExport() {
  const {file} = useParams<{file: string}>()
  const url = api(`/image_entries/${file}`)
  return <DownloadFile url={url} />
}
